import { render } from "./ItemManagement.vue?vue&type=template&id=a17bc9ce&scoped=true"
import script from "./ItemManagement.vue?vue&type=script&lang=js"
export * from "./ItemManagement.vue?vue&type=script&lang=js"

import "./ItemManagement.vue?vue&type=style&index=0&id=a17bc9ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a17bc9ce"]])

export default __exports__